import type { RouterConfig } from '@nuxt/schema';
import { getBasePath } from '~/utils/getBasePath';

// https://router.vuejs.org/api/#routeroptions
export default <RouterConfig>{
  scrollBehavior: (to, _from, savedPosition) => {
    // Мгновенный скролл наверх при смене страницы. До отрисовки его уже
    // выполняет plugins/scroll.client.ts (чтобы не мелькал футер) — здесь
    // фиксируется итоговая позиция.
    if (!savedPosition && getBasePath(to.fullPath) !== getBasePath(_from.fullPath)) {
      return { top: 0, left: 0 };
    }

    const nuxtApp = useNuxtApp();
    return new Promise((resolve) => {
      nuxtApp.hooks.hookOnce('page:finish', () => {
        if (to.hash) {
          resolve({ el: to.hash, behavior: 'smooth' });
          return;
        }

        if (savedPosition) {
          setTimeout(() => {
            resolve({
              left: savedPosition.left ?? 0,
              top: savedPosition.top ?? 0,
              behavior: 'smooth'
            });
          }, 300);
          return;
        }

        resolve({ top: 0, left: 0 });
      });
    });
  }
};
